var ToolbarContainerTagMap = [
    ['div', 'div'],
    ['header', 'header'],
    ['section', 'section']
];
var UitkToolbarContainerTags = new Map(ToolbarContainerTagMap);
var UitkToolbarNavigationTypeIconsMap = [
    ['close', 'close'],
    ['back', 'arrow_back'],
    ['expand_up', 'expand_less'],
    ['expand_down', 'expand_more']
];
var UitkToolbarNavigationTypeIcons = new Map(UitkToolbarNavigationTypeIconsMap);
var UitkToolbarTitleTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6']
];
var UitkToolbarTitleTags = new Map(UitkToolbarTitleTagMap);
var UitkToolbarTypesMap = [
    ['standard', 'standard'],
    ['transparent', 'transparent']
];
var UitkToolbarTypes = new Map(UitkToolbarTypesMap);

export { UitkToolbarContainerTags, UitkToolbarNavigationTypeIcons, UitkToolbarTitleTags, UitkToolbarTypes };
